import * as IconSelector from '../icons';

export const tiposGasto = [
    {
        value: 'Normal',
        label: 'Normal',
        description: 'Normal',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Con recargo',
        label: 'Con recargo',
        description: 'Operación normal con recargo',
        icon: IconSelector.PointIcon,
        color: 'Brown'
    },
    {
        value: 'Rectificativo',
        label: 'Rectificativo',
        description: 'Rectificativo',
        icon: IconSelector.PointIcon,
        color: 'Red'
    },
    {
        value: 'Intracomunitario',
        label: 'Intracomunitario',
        description: 'Intracomunitario',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Exento',
        label: 'Exento',
        description: 'Exento',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    },
    {
        value: 'Inversion Sujeto Pasivo',
        label: 'Inversion Sujeto Pasivo',
        description: 'Inversion Sujeto Pasivo',
        icon: IconSelector.PointIcon,
        color: 'Black'
    }
];
